export const SuccessMessage = {
  login: 'loggedInSuccess',
  gameClose: 'gameClosedSuccess',
  betPlacedSuccessfully: 'betPlacedSuccessfully',
  playerEscapedSuccessfully: 'playerEscapedSuccessfully',
  betCancelledSuccessfully: 'betCancelledSuccessfully'
}

export const ErrorMessage = {
  internalServerError: 'internalServerError',
  unAuthorized: 'unAuthorized'
}
